import React, { MouseEventHandler, useCallback } from "react";
import _ from "lodash";
import { ICellRendererParams } from "ag-grid-community";
import classnames from "classnames";
import { format } from "lib/globalize-util";
import { IRowData } from "components/shipment-review/types";
import { getAvailableInventory } from "containers/legacy-cart/helpers";
import { SHIPMENT_REVIEW } from "constants/integration/shipment-review";
import me from "models/me";
import { EditableCallbackParams } from "ag-grid-community/dist/lib/entities/colDef";
import { isMatchLocation } from "helpers/legacy-cart/bulk";

// TODO: replace with InputRenderer
export const ShipmentSizeRenderer = (props: CastProp<ICellRendererParams, "data", IRowData>) => {
    const { node, data, value, colDef, column, api } = props;
    const colId = column.getColId();
    const sizeData = data.sizes[colId];
    const { quantity = 0 } = sizeData ?? {};

    const isCellEnabled = _.isFunction(colDef.editable)
        ? colDef.editable(props as EditableCallbackParams)
        : colDef.editable;

    // TODO: replace with singleClickEdit colDef option
    const handleQuantityClick: MouseEventHandler = useCallback(() => {
        if (isCellEnabled && !node.rowPinned) {
            api.startEditingCell({
                colKey: column,
                rowIndex: node.rowIndex,
            });
        }
    }, [api, column, isCellEnabled, node.rowIndex, node.rowPinned]);

    if (value === undefined || quantity === undefined) {
        return <span className="pinnedCell" data-test={SHIPMENT_REVIEW.EMPTY_SIZE_FIELD} />;
    }
    const inventory = getAvailableInventory(sizeData, {
        useDisplayInventory: me.hasPermission("display_inventory"),
        quantity,
        prebook: data.item.prebook,
    });

    return (
        <>
            <div className="quantity-wrap">
                <div
                    className={classnames("quantity", {
                        zeroQuantity: isCellEnabled && quantity === 0,
                        notAvailable: !isCellEnabled,
                        strikethrough: data.available && !isMatchLocation(data),
                    })}
                    onClick={handleQuantityClick}
                    data-test={SHIPMENT_REVIEW.SIZE_FIELD_QUANTITY}
                >
                    {data.available ? quantity : format("NA")}
                </div>
            </div>
            {data.available && !data?.hideInventory && (
                <div className={"inventory"} data-test={SHIPMENT_REVIEW.SIZE_FIELD_INVENTORY}>
                    {inventory}
                </div>
            )}
        </>
    );
};
